// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"AppWrapper_appWrapper__3NAfy","noScroll":"AppWrapper_noScroll__3rCBs"};